module.exports = __webpack_public_path__ + "img/swal-success.c201842c.svg";